import {appAPI} from "../../../api";
import {
    ITelemetryPoint,
    ITelemetrySummary,
    IFuelEvent,
    IDailyMileage,
    IDailyFuelConsumption,
    IJournalResponse,
    IDailyMovement,
} from "../../../models/IMachineryTelemetry";

const basePath = `/machinery-telemetry`;

// ── Dashboard: единый ответ на все данные за период ─────────────────────────

export interface ITelemetryDashboard {
    summary: ITelemetrySummary;
    fuelHistory: ITelemetryPoint[];
    voltageHistory: ITelemetryPoint[];
    engineHistory: ITelemetryPoint[];
    fuelEvents: IFuelEvent[];
    dailyMileage: IDailyMileage[];
    dailyFuelConsumption: IDailyFuelConsumption[];
    journal: IJournalResponse;
    dailyMovement: IDailyMovement[];
}

export const machineryTelemetryAPI = {
    /**
     * Единый запрос для дашборда телеметрии.
     * GET /machinery-telemetry/dashboard?machinery_id=…&from=…&to=…
     */
    getDashboard: async (
        machineryId: string,
        from: string,
        to: string,
        signal?: AbortSignal,
    ): Promise<ITelemetryDashboard> => {
        const res = await appAPI.get(`${basePath}/dashboard`, {
            params: {machinery_id: machineryId, from, to},
            signal,
        });
        return res.data;
    },

    /** Последняя точка телеметрии — отдельный запрос (зависит только от machineryId) */
    getLatest: async (
        machineryId: string,
        signal?: AbortSignal,
    ): Promise<ITelemetryPoint | null> => {
        const res = await appAPI.get(`${basePath}/latest`, {
            params: {machinery_id: machineryId},
            signal,
        });
        return res.data;
    },
};